import React from 'react'
import { Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { ReactComponent as MessengerSvgIcon } from '../../assets/img/messenger.svg'
import { Facebook as FacebookIcon } from '@material-ui/icons'

const useStyles = makeStyles((theme) => ({
  fbMessengerButton: {
    backgroundColor: '#1877F2',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#155db2',
    },

    textTransform: 'none',
    fontWeight: 'bold',

    borderRadius: '6px',
    padding: '6px',
  },

  messengerIcon: {
    width: '24px',
    height: '24px',
  },
}))

const FacebookMessengerButton = ({ children }) => {
  const classes = useStyles()

  const handleClick = () => {
    window.open('https://m.me/adokiapp', '_blank')
  }

  return (
    <Button
      onClick={handleClick}
      startIcon={<FacebookIcon className={classes.messengerIcon} />}
      className={classes.fbMessengerButton}
    >
      {children}
    </Button>
  )
}

export default FacebookMessengerButton
export { FacebookMessengerButton }
